import { render, staticRenderFns } from "./SuspensePattern.vue?vue&type=template&id=a5971340&"
import script from "./SuspensePattern.vue?vue&type=script&setup=true&lang=js&"
export * from "./SuspensePattern.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports